// RESOURCES

jQuery(document).ready(function ($) {

    $('.c-resources--nav li').each(function (index) {

        $(this).on("click", function () {
            $('.c-resources--nav li').removeClass('active');
            var resource = $(this).attr('class');
            $(this).addClass('active');
            $('.c-resources--content > div').removeClass('active');
            $("." + resource + "-content").addClass('active');
            $("#accordion").accordion("refresh");
        });

    });

});

// RESOURCES PRIVATE

jQuery(document).ready(function ($) {

    $('.c-resources-private--nav li').each(function (index) {

        $(this).on("click", function () {
            $('.c-resources-private--nav li').removeClass('active');
            var resource = $(this).attr('class');
            $(this).addClass('active');
            $('.c-resources-private--content > div').removeClass('active');
            $("." + resource + "-content").addClass('active');
            $("#accordion").accordion("refresh");
        });

    });

});

// Mobile

jQuery(document).ready(function ($) {

    $('.c-resources--nav__btn').on('click', function (e) {
        $(this).toggleClass('active');
        $(this).next('ul').toggle();
        $('#accordion').accordion('refresh');
    });

    if ($(window).width() < 768) {
        $('.c-resources--nav li').on('click', function () {
            $('.c-resources--nav').hide();
            $('.c-resources--nav__btn').removeClass('active');
            $('#accordion').accordion('refresh');
        });
    }

});
